import config from '../config';

export const CRUST_EXTRA = 'Корочка';
export const CRUST_EXTRA_EN = 'Crust';
export const CRUST_EXTRA_PL= 'Skorupa';
export const MOZZARELLA = 'сыр моцарелла1';
export const MOZZARELLA_EN = 'mozzarella cheese1';
export const MOZZARELLA_DE = 'mozzarella-käse1';
export const MOZZARELLA_DE_VEGAN = 'käse vegan sheese1';
export const timeZones = [
  { id: 'Europe/Kaliningrad', value: 'Калининград' },
  { id: 'Europe/Moscow', value: 'Москва' },
  { id: 'Europe/Samara', value: 'Самара' },
  { id: 'Asia/Yekaterinburg', value: 'Екатеринбург' },
  { id: 'Asia/Omsk', value: 'Омск' },
  { id: 'Asia/Krasnoyarsk', value: 'Красноярск' },
  { id: 'Asia/Irkutsk', value: 'Иркутск' },
  { id: 'Asia/Yakutsk', value: 'Якутск' },
  { id: 'Asia/Vladivostok', value: 'Владивосток' },
  { id: 'Asia/Magadan', value: 'Магадан' }
];

export const payloadTooLarge = (locale) => {
  const lang = config.legal === 'kz' || config.legal === 'kg' ? 'en' : locale;
  const messageOptions = {
    ru: 'Слишком большой размер файла',
    en: 'The attachment is too large'
  };
  return messageOptions[lang];
};
export const unprocessableEntity = (locale) => {
  const lang = config.legal === 'kz' || config.legal === 'kg' ? 'en' : locale;
  const messageOptions = {
    ru: 'Неверный тип изображения',
    en: 'Invalid image type'
  };
  return messageOptions[lang];
};



